import React, { useState, useEffect } from "react";
import { Form, Typography, message, Modal, Col, Row, Radio, Space } from "antd";
import http from "../../../../../services/http";
import { EditOutlined } from "@ant-design/icons";
const { Text } = Typography;

export function ModalFormulario({ id, open, onClose, onFinish }) {
	const [form] = Form.useForm();
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		carregarFormulario(id);
	}, [id]);

	// CARREGAR FORMULÁRIO
	const carregarFormulario = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("get", `v1/treinamentos_formularios/carregar_lancamento/${id}`, []);
		if (api.statusCode === 200) {
			setData(api.response.data);
		} else {
			onClose();
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// SALVAR FORMULÁRIO
	const salvarFormulario = async (formData) => {
		setLoading(true);
		const api = await http("post", `v1/treinamentos_formularios/salvar_lancamento`, formData);
		if (api.statusCode === 200) {
			message.success("Avaliação realizada com sucesso!");
			onFinish();
		} else {
			onClose();
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ON SUBMIT
	const onSubmit = (values) => {
		const formData = {
			id: data?.id,
			questoes: values,
		};
		salvarFormulario(formData);
	};

	return (
		<Modal
			title={
				<Text style={{ fontSize: 20 }}>
					<EditOutlined /> {data?.descricao}
				</Text>
			}
			open={open}
			onOk={() => form.submit()}
			okText="Salvar"
			width={1200}
			okButtonProps={{ size: "large", loading: loading, disabled: data?.status !== 2 }}
			cancelButtonProps={{ size: "large", loading: loading }}
			onCancel={() => {
				onClose();
			}}>
			<Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
				<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
					{data?.questoes?.map((quest) => {
						return (
							<Col key={quest?.id} className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
								<Form.Item
									name={quest?.id}
									label={quest?.descricao}
									rules={[{ required: true, message: "Selecione uma alternativa!" }]}
									initialValue={quest?.alternativas?.filter((e) => e?.status === 1)[0]?.id}>
									<Radio.Group disabled={data?.status !== 2}>
										<Space direction="vertical">
											{quest?.alternativas?.map((alt) => (
												<Radio key={alt?.id} value={alt?.id}>
													<Text>{alt?.descricao}</Text>
												</Radio>
											))}
										</Space>
									</Radio.Group>
								</Form.Item>
							</Col>
						);
					})}
				</Row>
			</Form>
		</Modal>
	);
}
